/* eslint-env browser */
import React from 'react';
import { render } from 'react-dom';
import { SignupForm } from './components';

export default props => render(<SignupForm {...props} />, document.getElementById('signup-app'));



// WEBPACK FOOTER //
// ./src/modules/signupForm/client.js